export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carGarage.afe3bd8f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};